import { AbstractControl, FormControl, ValidationErrors } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export function validateDateChronology(from: string, to: string) {
  return (control: AbstractControl): ValidationErrors | null => {
    const fromDate: Date = control.get(from).value;
    const toDate: Date = control.get(to).value;

    return fromDate <= toDate ? null : { validChronology: true };
  };
}

export class DateChronologyErrorStateMatcher implements ErrorStateMatcher {
  constructor(private formSubmittedFn: () => boolean) {}

  isErrorState(control: FormControl | null): boolean {
    const isSubmitted = this.formSubmittedFn();
    const hasChronologyError = control?.parent?.hasError('validChronology') ?? false;
    const hasOwnError = control?.invalid ?? false;
    return isSubmitted && (hasChronologyError || hasOwnError);
  }
}
